import { MediaState } from './media.reducer';
import { Store } from '../../store/store.model';

export const selectMedia = (store: Store): MediaState => store.media;
